import twemoji from 'twemoji';
import { allCountries } from 'country-telephone-data';
import mapValues from 'lodash.mapvalues';
var codePoints = {
  A: "\uD83C\uDDE6",
  B: "\uD83C\uDDE7",
  C: "\uD83C\uDDE8",
  D: "\uD83C\uDDE9",
  E: "\uD83C\uDDEA",
  F: "\uD83C\uDDEB",
  G: "\uD83C\uDDEC",
  H: "\uD83C\uDDED",
  I: "\uD83C\uDDEE",
  J: "\uD83C\uDDEF",
  K: "\uD83C\uDDF0",
  L: "\uD83C\uDDF1",
  M: "\uD83C\uDDF2",
  N: "\uD83C\uDDF3",
  O: "\uD83C\uDDF4",
  P: "\uD83C\uDDF5",
  Q: "\uD83C\uDDF6",
  R: "\uD83C\uDDF7",
  S: "\uD83C\uDDF8",
  T: "\uD83C\uDDF9",
  U: "\uD83C\uDDFA",
  V: "\uD83C\uDDFB",
  W: "\uD83C\uDDFC",
  X: "\uD83C\uDDFD",
  Y: "\uD83C\uDDFE",
  Z: "\uD83C\uDDFF"
};
var isoUnicode = allCountries.reduce(function (isoMap, country) {
  var iso2 = country.iso2;
  var key = iso2.toUpperCase();
  var utfCode = "".concat(codePoints[key[0]]).concat(codePoints[key[1]]);
  /* eslint-disable no-param-reassign */

  isoMap[key] = utfCode;
  /* eslint-enable no-param-reassign */

  return isoMap;
}, {}); // Explicitly add non-countries which have currencies to the list of flags.

isoUnicode.EU = "".concat(codePoints.E).concat(codePoints.U);
var emojiFlags = mapValues(isoUnicode, function (code) {
  return twemoji.parse(code).replace('class="emoji"', 'class="select-emoji');
});
export default emojiFlags;